import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs';
import { FileService } from '../file/file.service';

@Injectable({
  providedIn: 'root',
})
export class AssetsService {
  private readonly apiUrl = '/simulation-api/assets/protected';

  constructor(
    private readonly httpClient: HttpClient,
    private readonly fileService: FileService,
  ) {}

  downloadProtectedAsset(filename: string): void {
    this.httpClient
      .get(`${this.apiUrl}/${filename}`, { responseType: 'blob' })
      .pipe(tap((blob: Blob) => this.fileService.downloadFileFromBlobObject(blob, filename)))
      .subscribe();
  }
}
